import React from 'react';

export const getPayrollUI = (frequency, payroll_info_semi_monthly, payroll_info_monthly, register, isCustomerIdNumeric, Select, reactSelectClassNames, setValue, clearErrors, selectedPayrollValue, setSelectedPayrollValue) => {
  if (frequency === '') {
    return null;
  } else if (frequency === 'pay_frequency_weekly') {
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    return (
      <div className="py-2">
        <p className="has-text-grey is-small is-size-7">
          <span className="mr-1">Select Pay Day Of Week</span>
          <span className="has-text-danger">*</span>
        </p>
        {days.map((day, index) => (
          <div key={day} className="field">
            <input className="is-checkradio" id="payDayOfWeek" type="radio" name="payDayOfWeek" value={day} {...register("payDayOfWeek", { required: false })} disabled={isCustomerIdNumeric()} onChange={(e) => { if (e.value != "") clearErrors('payroll_info') }} />
            <label htmlFor={day}> {day}</label>
          </div>
        ))}
      </div>
    );
  } else if (frequency === 'pay_frequency_biweekly') {
    return (
      <div className="py-2">
        <p className="has-text-grey is-small is-size-7">
          <span className="mr-1">Select First Pay Day</span>
          <span className="has-text-danger">*</span>
        </p>
        <input
          id="firstPayDay"
          name="firstPayDay"
          className="input is-small"
          type="date"
          disabled={isCustomerIdNumeric()} // Disable if Customer ID has a numeric value
          placeholder="First Pay Day"
          {...register('firstPayDay', {
            required: false
          })}
          onChange={(e) => { if (e.value != "") clearErrors('payroll_info') }}
        />
      </div>
    );
  } else if (frequency === 'pay_frequency_semimonthly') {
    const semiMonthlyOptions = [
      { value: 'specificDays', label: 'Specific Days' },
      { value: 'weekdayAndWeekOfMonth', label: 'Week Day and Week of Month' },
    ]
    return (
      <div>
        <div>
          <Select
            name="payroll_info_semi_monthly"
            classNames={reactSelectClassNames()}
            options={semiMonthlyOptions}
            isDisabled={isCustomerIdNumeric()} // Disable if Customer ID has a numeric value
            onChange={(e) => { setValue('payroll_info_semi_monthly', e.value); if (e.value != "") clearErrors('payroll_info'); setSelectedPayrollValue(e) }}
            value={selectedPayrollValue}
            isSearchable={false}
          />
        </div>
        {getSemiMonthlyPayrollUI(payroll_info_semi_monthly, register, isCustomerIdNumeric, clearErrors)}
      </div>
    );
  } else if (frequency === 'pay_frequency_monthly') {
    const monthlyOptions = [
      { value: 'payDayOfMonth', label: 'Pay Day of Month' },
      { value: 'weekdayAndWeekOfMonth', label: 'Week Day and Week of Month' },
    ]
    return (
      <div>
        <div>
          <Select
            name="payroll_info_monthly"
            classNames={reactSelectClassNames()}
            options={monthlyOptions}
            isDisabled={isCustomerIdNumeric()} // Disable if Customer ID has a numeric value
            onChange={(e) => { setValue('payroll_info_monthly', e.value); if (e.value != "") clearErrors('payroll_info'); setSelectedPayrollValue(e) }}
            value={selectedPayrollValue}
            isSearchable={false}
          />
        </div>
        {getMonthlyPayrollUI(payroll_info_monthly, register, isCustomerIdNumeric, clearErrors)}
      </div>
    );
  }
}

const getMonthlyPayrollUI = (payroll_info_monthly, register, isCustomerIdNumeric, clearErrors) => {
  if (payroll_info_monthly === 'payDayOfMonth') {
    return (
      <div className="py-2">
        <input
          id="payDayOfMonth"
          name="payDayOfMonth"
          className="input is-small"
          type="number"
          max="31"
          min="1"
          disabled={isCustomerIdNumeric()} // Disable if Customer ID has a numeric value
          placeholder="Pay Day of Month"
          {...register('payDayOfMonth', {
            required: false
          })}
          onChange={(e) => { if (e.value != "") clearErrors('payroll_info') }}
        />
      </div>
    );
  } else if (payroll_info_monthly === 'weekdayAndWeekOfMonth') {
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    return (
      <div className="py-2">
        <p className="has-text-grey is-small is-size-7">
          <span className="mr-1">Select Pay Days Of Week</span>
          <span className="has-text-danger">*</span>
        </p>
        {days.map((day, index) => (
          <div key={day} className="field">
            <input className="is-checkradio" id="dayOfWeek" type="radio" name="dayOfWeek" value={day} {...register("dayOfWeek", { required: false })} disabled={isCustomerIdNumeric()} onChange={(e) => { if (e.value != "") clearErrors('payroll_info') }} />
            <label htmlFor={day}> {day}</label>
          </div>
        ))}
        <input
          id="weekOfMonth"
          name="weekOfMonth"
          className="input is-small"
          type="text"
          disabled={isCustomerIdNumeric()}
          placeholder="Week Number"
          {...register('weekOfMonth', {
            required: false
          })}
          onChange={(e) => { if (e.value != "") clearErrors('payroll_info') }}
        />
      </div>
    );
  } else {
    return null;
  }
}

const getSemiMonthlyPayrollUI = (payroll_info_semi_monthly, register, isCustomerIdNumeric, clearErrors) => {
  if (payroll_info_semi_monthly === 'specificDays') {
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    return (
      <div className="py-2">
        <p className="has-text-grey is-small is-size-7">
          <span className="mr-1">Please select two specific days between 1-31</span>
          <span className="has-text-danger">*</span>
        </p>
        {Array.from({ length: 31 }, (_, i) => i + 1).map((day, index) => (
          <label className="checkbox" style={{ width: "40px" }} key={day}>
            <input className="is-checkradio" id="specificDays[]" type="checkbox" name="specificDays[]" value={day} {...register("specificDays[]", { required: false })} disabled={isCustomerIdNumeric()} onChange={(e) => { if (e.value != "") clearErrors('payroll_info') }} /> {day}
          </label>
        ))}
      </div>
    );
  } else if (payroll_info_semi_monthly === 'weekdayAndWeekOfMonth') {
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    return (
      <div className="py-2">
        <p className="has-text-grey is-small is-size-7">
          <span className="mr-1">Select Pay Days Of Week</span>
          <span className="has-text-danger">*</span>
        </p>
        {days.map((day, index) => (
          <div key={day} className="field">
            <input className="is-checkradio" id="dayOfWeek1" type="radio" name="dayOfWeek1" value={day} {...register("dayOfWeek1", { required: false })} disabled={isCustomerIdNumeric()} onChange={(e) => { if (e.value != "") clearErrors('payroll_info') }} />
            <label htmlFor={day}> {day}</label>
          </div>
        ))}
        <input
          id="weekOfMonth1"
          name="weekOfMonth1"
          className="input is-small"
          type="number"
          max="5"
          min="1"
          disabled={isCustomerIdNumeric()}
          placeholder="Week Number"
          {...register('weekOfMonth1', {
            required: false
          })}
          onChange={(e) => { if (e.value != "") clearErrors('payroll_info') }}
        />
        <p className="has-text-grey is-small is-size-7">
          <span className="mr-1">Select Pay Days Of Week</span>
          <span className="has-text-danger">*</span>
        </p>
        {days.map((day, index) => (
          <div key={day} className="field">
            <input className="is-checkradio" id="dayOfWeek2" type="radio" name="dayOfWeek2" value={day} {...register("dayOfWeek2", { required: false })} disabled={isCustomerIdNumeric()} onChange={(e) => { if (e.value != "") clearErrors('payroll_info') }} />
            <label htmlFor={day}> {day}</label>
          </div>
        ))}
        <input
          id="weekOfMonth2"
          name="weekOfMonth2"
          className="input is-small"
          type="number"
          max="5"
          min="1"
          disabled={isCustomerIdNumeric()}
          placeholder="Week Number"
          {...register('weekOfMonth2', {
            required: false
          })}
          onChange={(e) => { if (e.value != "") clearErrors('payroll_info') }}
        />
      </div>
    );
  } else {
    return null;
  }
}
